<!-- Static summary (no collapsible body): avoid mat-expansion-panel so header is not a false expand button -->
<div class="!m-0 max-w-full min-w-0 !rounded-none !shadow-none !box-border">
  <div class="!bg-[#F3F5F7B2] box-border !shadow-none !px-3 flex w-full min-w-0 max-w-full items-center overflow-x-clip"
    [class]="direction">
    <!-- flex-1 basis-0: avoid w-full child wider than gray bar (flex % width + min-content bug) -->
    <div class="min-w-0 max-w-full flex-1 basis-0 !box-border py-2">
      <div class="flex max-w-full min-w-0 justify-between gap-2" [class]="direction"
        (click)="focusLocationEvent.emit(section.arrival?.place?.location)">
        <div class="flex min-w-0 flex-1 basis-0 items-center gap-2">
          <ng-icon name="walking person"
            class="section-icon shrink-0 text-2xl relative border-2 border-solid !border-[#AD76F9] p-2" [ngClass]="{
              'section-icon--first': index == 0,
              'section-icon--last': index == length - 1
            }" style="border-radius: 50%" />

          <span class="flex flex-col gap-[0.125rem] min-w-0">
            <span class="font-normal text-sm text-[#0C3058]">{{
              walkingToText
              }}</span>
            <span class="text-[#0C3058] !text-base">{{
              getWalkDestinationName()
              }}</span>
            @if (section.arrival.place.code) {
            <span class="font-normal text-sm text-[#0C3058]">{{ stationCodeText }}: {{ section.arrival.place.code
              }}</span>
            }
            @if (section.arrival.place.platformNumber) {
              <span class="font-normal text-sm text-[#0C3058]">{{ platformText }}: {{ section.arrival.place.platformNumber
                }}
              </span>
              }
          </span>
        </div>

        <span class="shrink-0 ps-1 tabular-nums text-[#0C3058]">{{
          section.departure.hourTimeString | hour
          }}</span>
      </div>
    </div>
  </div>
</div>

@if (!!section.actions && !!section.actions.length) {
<mat-expansion-panel class="!m-0 !rounded-none !bg-transparent !shadow-none">
  <mat-expansion-panel-header class="!bg-transparent !shadow-none !px-6 !h-12" [class]="direction">
    <mat-panel-title class="!m-0 text-primary !gap-6 !px-2">
      <mat-divider [vertical]="true" color="#AD76F9" class="!border-r-solid !border-r-[#AD76F9] h-full"
        style="margin-right: 1px; margin-left: 1px" />
      <div class="flex items-center h-full pt-2">
        <span class="flex text-primary gap-2 items-center">
          <span class="text-sm font-normal text-[#0068F5]">{{
            calculatedDurationText
            }}</span>
          <span class="text-subText text-sm" aria-hidden="true">•</span>
          <span class="text-sm font-normal text-[#0068F5]">{{ calcSectionDistance() }}
            {{ distanceUnitShortText }}</span>
        </span>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <!--
              a11y: turn-by-turn walking directions exposed as a native ordered
              list. role="list" + role="listitem" guards against Safari's
              long-standing quirk where `list-style: none` strips list semantics
              from the a11y tree. aria-label gives the list a discoverable name.
            -->
  <ol class="flex flex-col gap-2 px-8 list-none m-0" [class]="direction" role="list"
    [attr.aria-label]="walkingDirectionsListLabel">
    @for (
    action of section.actions; track
    action; let actionIndex = $index; let isLastAction = $last) {
    <li class="flex justify-between" role="listitem">
      <div class="flex gap-5 items-center">
        <app-stop-indicator [isLastStop]="isLastAction" class="!h-full" topLineClass="!h-1/2"
          bottomLineClass="!h-1/2" [isPedestrian]="true"/>
        <span class="stop-name text-[#0C3058]">{{ action.instruction }}</span>
      </div>
    </li>
    }
  </ol>
  <!-- <mat-divider
              [vertical]="true"
              color="primary"
              class="h-4 !border-solid !border-t-0 !border-b-0"
    [ngClass]="{
      '!border-r-primary': direction === 'rtl',
      '!border-l-primary': direction === 'ltr'
    }"
    [ngStyle]="
      direction === 'rtl'
        ? { 'margin-right': 'calc(2rem + 1px)' }
        : { 'margin-left': 'calc(2rem + 1px)' }
    "
              /> -->
</mat-expansion-panel>
}